module.exports = __webpack_public_path__ + "static/media/video1.568fe4a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video1.mp4
// module id = JWf0
// module chunks = 1